import { COMPONENT_CREATED, DATE_FILTER_UPDATED, GROUP_FILTER_UPDATED } from '../Actions/DateFilter'

const initialState = {
  currentComponent: null,
  previousComponent: null,
  screens: {}
}
/*
{
 currentComponent: 'News Feed',
   screen: {
   'News Feed': {
     groupFiler: ['231287dsnkczo'],
     dateFilter: 'Week'
  }
}
} */

export default function DateFilerReducer (state = initialState, action = {}) {
  switch (action.type) {
    case COMPONENT_CREATED: return {
      ...state,
      currentComponent: action.data.componentName,
      previousComponent: state.currentComponent,
      screens: {
        ...state.screens
      }
    }
    case DATE_FILTER_UPDATED:return {
      ...state,
      currentComponent: action.data.componentName,
      screens: {
        ...state.screens,
        [action.data.componentName]: {
          ...state.screens[action.data.componentName],
          ...action.data
        }
      }
    }
    case GROUP_FILTER_UPDATED:
    {
      return {
        ...state,
        currentComponent: action.data.componentName,
        screens: {
          ...state.screens,
          [action.data.componentName]: {
            ...state.screens[action.data.componentName],
            groupFilter: action.data.groupFilter
          }
        }
      }
    }

    default:
      return state
  }
}
